export default "__VITE_ASSET__BMmq9qXU__"